import { Box, Heading, Text } from '@chakra-ui/react';

import ErrorComponent from '../../components/ErrorComponent';
import Loading from '../../components/Loading';
import { useGetAllEvaluationEvents } from '../../hooks/useGetAllEvaluationEvents';
import i18n from '../../utils/i18n';

import { EvaluationEventsList } from './EvaluationEventsList';

export const EvaluationEvents = () => {
  const {
    data: evaluationEvents,
    isLoading,
    isError,
  } = useGetAllEvaluationEvents();

  if (isLoading) return <Loading />;
  if (isError) return <ErrorComponent />;

  return (
    <>
      <Box aria-label="event-surveys-title-section" mb={10}>
        <Heading as="h1" fontSize={24} lineHeight={8} fontWeight={600}>
          {i18n.t('evaluationEvent.title')}
        </Heading>
        <Text>{i18n.t('evaluationEvent.subTitle')}</Text>
      </Box>

      <EvaluationEventsList evaluationEvents={evaluationEvents} />
    </>
  );
};
